import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { StaticSlide } from 'components/staticslide'
import { ComicSlide } from 'components/comicslide'
import { Slide02 } from 'components/slide02'
import { Slide02Mobile } from 'components/slide02mobile'
import { Slide16 } from 'components/slide16'
import { Slide16Mobile } from 'components/slide16mobile'
import { Footer } from 'components/footer'
import ReactFullpage from '@fullpage/react-fullpage'

const ARTICLE_ID = '30204491'
const ADDITIONAL_SHARES = 855

const img0 = require('./img/00.jpg')
const img0mobile = require('./img/00-mobile.jpg')
const img1 = require('./img/01.jpg')
const img1mobile = require('./img/01-mobile.jpg')
const img2 = require('./img/02.jpg')
const img2a = require('./img/02a.png')
const img2mobile = require('./img/02-mobile.jpg')
const img2amobile = require('./img/02a-mobile.png')
const img3 = require('./img/03.jpg')
const img3mobile = require('./img/03-mobile.jpg')
const img4 = require('./img/04.jpg')
const img4mobile = require('./img/04-mobile.jpg')
const img5 = require('./img/05.jpg')
const img5mobile = require('./img/05-mobile.jpg')
const img5amobile = require('./img/05a-mobile.jpg')
const img6 = require('./img/06.jpg')
const img6mobile = require('./img/06-mobile.jpg')
const img7 = require('./img/07.jpg')
const img7mobile = require('./img/07-mobile.jpg')
const img8 = require('./img/08.jpg')
const img8mobile = require('./img/08-mobile.jpg')
const img9 = require('./img/09.jpg')
const img9mobile = require('./img/09-mobile.jpg')
const img10 = require('./img/10.jpg')
const img10mobile = require('./img/10-mobile.jpg')
const img11 = require('./img/11.jpg')
const img11mobile = require('./img/11-mobile.jpg')
const img12 = require('./img/12.jpg')
const img12mobile = require('./img/12-mobile.jpg')
const img12amobile = require('./img/12a-mobile.jpg')
const img13 = require('./img/13.jpg')
const img13mobile = require('./img/13-mobile.jpg')
const img14 = require('./img/14.jpg')
const img14mobile = require('./img/14-mobile.jpg')
const img15 = require('./img/15.jpg')
const img15mobile = require('./img/15-mobile.jpg')
const img16 = require('./img/16.jpg')
const img16a = require('./img/16a.png')
const img16b = require('./img/16b.png')
const img16c = require('./img/16c.png')
const img16d = require('./img/16d.png')
const img16mobile = require('./img/16-mobile.jpg')
const img16amobile = require('./img/16a-mobile.png')
const img16bmobile = require('./img/16b-mobile.png')
const img16cmobile = require('./img/16c-mobile.png')
const img17 = require('./img/17.jpg')
const img17mobile = require('./img/17-mobile.jpg')
const img18 = require('./img/18.jpg')
const img18mobile = require('./img/18-mobile.jpg')
const img18amobile = require('./img/18a-mobile.jpg')
const img19 = require('./img/19.jpg')
const img19mobile = require('./img/19-mobile.jpg')
const img20 = require('./img/20.jpg')
const img20mobile = require('./img/20-mobile.jpg')
const img21 = require('./img/21.jpg')
const img21mobile = require('./img/21-mobile.jpg')
const img21amobile = require('./img/21a-mobile.jpg')
const img22 = require('./img/22.jpg')
const img22mobile = require('./img/22-mobile.jpg')
const img23 = require('./img/23.jpg')
const img23mobile = require('./img/23-mobile.jpg')
const img23amobile = require('./img/23a-mobile.jpg')
const img24 = require('./img/24.jpg')
const img24mobile = require('./img/24-mobile.jpg')
const img24amobile = require('./img/24a-mobile.jpg')
const img24bmobile = require('./img/24b-mobile.jpg')
const img25 = require('./img/25.jpg')
const img25mobile = require('./img/25-mobile.jpg')
const img25amobile = require('./img/25a-mobile.jpg')
const img26 = require('./img/26.jpg')
const img26mobile = require('./img/26-mobile.jpg')
const img26amobile = require('./img/26a-mobile.jpg')
const img27 = require('./img/27.jpg')
const img27mobile = require('./img/27-mobile.jpg')

class AppComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 800,
      slideTransition: 'slide', // slide|fade
      activeSlide: 0,
      totalSlides: 0,
      publicationDate: Date.now() / 1000,
      hasPaywall: false
    }
    this.onLeave = this.onLeave.bind(this)
    this.afterLoad = this.afterLoad.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }

  updateDimensions() {
    // console.log('updateDimensions')
    this.setState({ isMobile: window.innerWidth < 800 })
  }

  onLeave(index, nextIndex, direction) {
    // console.log('onLeave')
    this.setState({ isSliding: true })

    // console.log('nextIndex: ', nextIndex.index)
    window.dataLayer = window.dataLayer || []
    const slideLabel = window.dataLayer.push({
      event: 'Interactions',
      event_action: 'scroll',
      event_label: `scrolled to: ${nextIndex.index}`
    })
  }

  afterLoad(anchorLink, index, slideAnchor, slideIndex) {
    // console.log('afterLoad')
    this.setState({ isSliding: false })

    // paywall?
    const wallElem = document.getElementById('paywall_container')
    if (wallElem === null || !wallElem.children.length) {
      // console.log('NO paywall...')
      this.setState({ hasPaywall: false })
    } else {
      // console.log('has paywall!')
      this.setState({ hasPaywall: true })
      return false
    }

    // console.log('active index: ', index.index)
    this.setState({ activeSlide: index.index })
    this.setState({
      totalSlides: document.querySelectorAll('.fp-section').length - 1
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  render() {
    return (
      <div className={'index ' + this.state.slideTransition}>
        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
        {!this.state.hasPaywall && (
          <div className='progress'>
            {this.state.activeSlide + 1 + '/' + (this.state.totalSlides + 1)}
          </div>
        )}
        <ReactFullpage
          onLeave={this.onLeave}
          afterLoad={this.afterLoad}
          navigation={false}
          navigationPosition='right'
          navigationTooltips={['', '', '']}
          licenseKey='9B91FA5D-FFD748B8-88A4F827-CEF667F2'
          render={({ state, fullpageApi }) => {
            return (
              <ReactFullpage.Wrapper>
                <ThemeSwitch />
                <div
                  className='section'
                  id='section-0'
                  slideIndex={0}
                  style={{
                    backgroundImage: `url(${
                      this.state.isMobile ? img0mobile : img0
                    })`
                  }}
                >
                  <h1>
                    «Die Killer verfolgen ihre Opfer bis in die Notaufnahme»
                  </h1>
                  <p className='lead' style={{ display: 'none' }}>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor invidunt ut labore et dolore magna
                    aliquyam erat.
                  </p>
                  <div className='scroll-hint'>
                    <p
                      style={{
                        textAlign: 'center',
                        color: this.state.isMobile ? '#fff' : '#333'
                      }}
                    >
                      <span
                        style={{
                          padding: '0.3em',
                          backgroundColor: this.state.isMobile
                            ? '#333'
                            : 'transparent'
                        }}
                      >
                        Bitte scrollen
                      </span>
                      <br />
                      <i
                        className='icon angle down large'
                        style={{
                          color: this.state.isMobile ? '#333' : '#333'
                        }}
                      />
                    </p>
                  </div>
                </div>
                {!this.state.isMobile && !this.state.hasPaywall && (
                  /* DESKTOP SLIDES */

                  <>
                    <StaticSlide
                      id='section-01'
                      slideIndex={1}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img1mobile}
                      imgDesktop={img1}
                      isSliding={this.state.isSliding}
                    />
                    <Slide02
                      id='section-02'
                      slideIndex={2}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img2mobile}
                      imgDesktop={img2}
                      imgOverlay={img2a}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-03'
                      slideIndex={3}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img3mobile}
                      imgDesktop={img3}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-04'
                      slideIndex={4}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img4mobile}
                      imgDesktop={img4}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-05'
                      slideIndex={5}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img5mobile}
                      imgDesktop={img5}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-06'
                      slideIndex={6}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img6mobile}
                      imgDesktop={img6}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-07'
                      slideIndex={7}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img7mobile}
                      imgDesktop={img7}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-08'
                      slideIndex={8}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img8mobile}
                      imgDesktop={img8}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-09'
                      slideIndex={9}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img9mobile}
                      imgDesktop={img9}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-10'
                      slideIndex={10}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img10mobile}
                      imgDesktop={img10}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-11'
                      slideIndex={11}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img11mobile}
                      imgDesktop={img11}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-12'
                      slideIndex={12}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img12mobile}
                      imgDesktop={img12}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-13'
                      slideIndex={13}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img13mobile}
                      imgDesktop={img13}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-14'
                      slideIndex={14}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img14mobile}
                      imgDesktop={img14}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-15'
                      slideIndex={15}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img15mobile}
                      imgDesktop={img15}
                      isSliding={this.state.isSliding}
                    />
                    <Slide16
                      id='section-16'
                      slideIndex={16}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img16mobile}
                      imgDesktop={img16}
                      imgA={img16a}
                      imgB={img16b}
                      imgC={img16c}
                      imgD={img16d}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-17'
                      slideIndex={17}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img17mobile}
                      imgDesktop={img17}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-18'
                      slideIndex={18}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img18mobile}
                      imgDesktop={img18}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-19'
                      slideIndex={19}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img19mobile}
                      imgDesktop={img19}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-20'
                      slideIndex={20}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img20mobile}
                      imgDesktop={img20}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-21'
                      slideIndex={21}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img21mobile}
                      imgDesktop={img21}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-22'
                      slideIndex={22}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img22mobile}
                      imgDesktop={img22}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-23'
                      slideIndex={23}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img23mobile}
                      imgDesktop={img23}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-24'
                      slideIndex={24}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img24mobile}
                      imgDesktop={img24}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-25'
                      slideIndex={25}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img25mobile}
                      imgDesktop={img25}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-26'
                      slideIndex={26}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img26mobile}
                      imgDesktop={img26}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-27'
                      slideIndex={27}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img27mobile}
                      imgDesktop={img27}
                      isSliding={this.state.isSliding}
                    />
                  </>

                  /* END DESKTOP SLIDES */
                )}

                {this.state.isMobile && !this.state.hasPaywall && (
                  /* MOBILE SLIDES */

                  <>
                    <StaticSlide
                      id='section-01'
                      slideIndex={1}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img1mobile}
                      imgDesktop={img1}
                      isSliding={this.state.isSliding}
                    />
                    <Slide02Mobile
                      id='section-02'
                      slideIndex={2}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img2mobile}
                      imgDesktop={img2}
                      imgOverlay={img2amobile}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-03'
                      slideIndex={3}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img3mobile}
                      imgDesktop={img3}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-04'
                      slideIndex={4}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img4mobile}
                      imgDesktop={img4}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-05'
                      slideIndex={5}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img5mobile}
                      imgDesktop={img5}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-05a'
                      slideIndex={6}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img5amobile}
                      imgDesktop={img5}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-06'
                      slideIndex={7}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img6mobile}
                      imgDesktop={img6}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-07'
                      slideIndex={8}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img7mobile}
                      imgDesktop={img7}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-08'
                      slideIndex={9}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img8mobile}
                      imgDesktop={img8}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-09'
                      slideIndex={10}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img9mobile}
                      imgDesktop={img9}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-10'
                      slideIndex={11}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img10mobile}
                      imgDesktop={img10}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-11'
                      slideIndex={12}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img11mobile}
                      imgDesktop={img11}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-12'
                      slideIndex={13}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img12mobile}
                      imgDesktop={img12}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-12a'
                      slideIndex={14}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img12amobile}
                      imgDesktop={img12}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-13'
                      slideIndex={15}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img13mobile}
                      imgDesktop={img13}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-14'
                      slideIndex={16}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img14mobile}
                      imgDesktop={img14}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-15'
                      slideIndex={17}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img15mobile}
                      imgDesktop={img15}
                      isSliding={this.state.isSliding}
                    />
                    <Slide16Mobile
                      id='section-16'
                      slideIndex={18}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img16mobile}
                      imgA={img16amobile}
                      imgB={img16bmobile}
                      imgC={img16cmobile}
                      imgDesktop={img16}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-17'
                      slideIndex={19}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img17mobile}
                      imgDesktop={img17}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-18'
                      slideIndex={20}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img18mobile}
                      imgDesktop={img18}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-18a'
                      slideIndex={21}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img18amobile}
                      imgDesktop={img18}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-19'
                      slideIndex={22}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img19mobile}
                      imgDesktop={img19}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-20'
                      slideIndex={23}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img20mobile}
                      imgDesktop={img20}
                      isSliding={this.state.isSliding}
                    />
                    {/*
                    <StaticSlide
                      id='section-21'
                      slideIndex={24}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img21mobile}
                      imgDesktop={img21}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-21a'
                      slideIndex={25}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img21amobile}
                      imgDesktop={img21}
                      isSliding={this.state.isSliding}
                    />
                    */}
                    <StaticSlide
                      id='section-22'
                      slideIndex={24}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img22mobile}
                      imgDesktop={img22}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-23'
                      slideIndex={25}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img23mobile}
                      imgDesktop={img23}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-23a'
                      slideIndex={26}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img23amobile}
                      imgDesktop={img23}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-24'
                      slideIndex={27}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img25mobile}
                      imgDesktop={img25}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-25'
                      slideIndex={28}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img24mobile}
                      imgDesktop={img24}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-25a'
                      slideIndex={29}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img24amobile}
                      imgDesktop={img25}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-25b'
                      slideIndex={30}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img24bmobile}
                      imgDesktop={img26}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-25c'
                      slideIndex={31}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img25amobile}
                      imgDesktop={img25}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-26'
                      slideIndex={32}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img26mobile}
                      imgDesktop={img26}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-26a'
                      slideIndex={33}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img26amobile}
                      imgDesktop={img26}
                      isSliding={this.state.isSliding}
                    />
                    <StaticSlide
                      id='section-27'
                      slideIndex={34}
                      activeSlide={this.state.activeSlide}
                      isMobile={this.state.isMobile}
                      imgMobile={img27mobile}
                      imgDesktop={img27}
                      isSliding={this.state.isSliding}
                    />
                  </>

                  /* END MOBILE SLIDES */
                )}

                {!this.state.hasPaywall && (
                  <div
                    className='section'
                    id='section-13'
                    style={{ padding: 0 }}
                  >
                    <Footer
                      articleId={ARTICLE_ID}
                      publicationDate={this.state.publicationDate}
                    />
                  </div>
                )}
              </ReactFullpage.Wrapper>
            )
          }}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
